import { render } from "./AppCurrencyControl.vue?vue&type=template&id=82a8e1f6&scoped=true"
import script from "./AppCurrencyControl.vue?vue&type=script&lang=js"
export * from "./AppCurrencyControl.vue?vue&type=script&lang=js"

import "@/assets/scss/components/sales/_app-currency-control.scss?vue&type=style&index=0&id=82a8e1f6&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82a8e1f6"]])

export default __exports__